<template>
  <div>
    <label class="label">{{title}}</label>

    <label
      v-for="(item,index) in values"
      :key="item.value"
      :for="sid+index"
      class="radio"
      v-bind:class="{'state-disabled':disabled, 'state-error': model.$error, 'radio-inline': inline}"
    >
      <input
        type="radio"
        :id="sid+index"
        :checked="item.value === model.$model"
        :disabled="disabled"
        :value="item.value"
        @change="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        :name="model.$form.testPath ? model.$path : undefined"
      >
      <i></i>
      {{item.text}}
    </label>
    <label
      v-if="otherLabel"
      :for="sid+'_free'"
      class="radio"
      v-bind:class="{'state-disabled':disabled, 'state-error': model.$error, 'radio-inline': inline}"
    >
      <input
        type="radio"
        :checked="otherIsClicked"
        :disabled="disabled"
        @change="onInputOther($event)"
        :name="model.$form.testPath ? model.$path : undefined"
      >
      <i></i>
      <span v-show="!otherIsClicked">{{otherLabel}}</span>
      <input
        class="form-control"
        :id="sid+'_free'"
        :class="{'borderless':borderless, 'text-right':model.$schema.type=='number'||model.$schema.type=='money'||model.$schema.type=='integer'}"
        :name="model.$form.testPath ? model.$path : undefined"
        v-show="otherIsClicked"
        :value="model.$value"
        ref="input"
        :placeholder="otherLabel"
        @input="onInputText"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
      >
    </label>
    <w-error :model="model"></w-error>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';

export default {
  mixins: [modelMixin],
  props: {
    values: {
      type: Array,
      default: () => [] //tablice trzeba zwracać przez funkcję
    },
    otherLabel: String,
    inline: Boolean
    // model: Object
  },

  data() {
    return {
      userOther: false,
      sid: 'rlist' + Math.round(Math.random() * 1000000)
    };
  },
  computed: {
    otherIsClicked() {
      if (!this.model.$value) {
        return this.userOther;
      }
      return !this.values.map(x => x.value).includes(this.model.$value);
    }
  },
  created() {
    console.log('creatd', this);
  },
  methods: {
    onInput(evt) {
      this.userOther = false;
      if (evt.target.checked) {
        this.model.$value = evt.target.value;
      }
    },
    onInputOther(evt) {
      console.log('userOther', this);
      this.userOther = true;
      console.log('onInputOther', this.model.$path);
      this.model.$value = '';
      this.model.$reset();
      setTimeout(() => {
        this.$refs.input.focus();
      }, 10);
    },
    onInputText(evt) {
      console.log('input text', this.model.$path);
      this.userOther = true;

      this.model.$value = evt.target.value;
    },
    onBlur(evt) {
      this.model.$hasFocus = false;
      this.$emit('blur', evt);
    },
    onFocus(evt) {
      this.model.$hasFocus = true;
      this.$emit('focus', evt);
    }
  }
};
</script>

<style>
</style>
